import React from 'react';
interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}
export const Logo: React.FC<LogoProps> = ({
  className = '',
  size = 'md'
}) => {
  const dimensions = {
    sm: {
      width: 128,
      height: 128
    },
    md: {
      width: 160,
      height: 160
    },
    lg: {
      width: 192,
      height: 192
    }
  };
  const {
    width,
    height
  } = dimensions[size];
  return <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kLyj1ED4L24NMRjRqQh5Xx/image.png" alt="Taskpoint Logo" width={width} height={height} className={className} style={{
    objectFit: 'contain'
  }} data-id="element-159" />;
};